export default __webpack_public_path__ + "static/media/login-background.39f22dce.jpg";